import comNews from '../../components/com-news.vue';
import comProduct from '../../components/com-product.vue';
import {removeRichTextLabel} from '../../assets/js/tools.js';
export default{
    name:'Information',
    data(){
        return{
            imgs:[
                // {
                //     path:'home-img1.png',
                //     title:'标题1',
                // },
                // {
                //     path:'home-img2.png',
                //     title:'标题2',
                // },
                // {
                //     path:'home-img3.png',
                //     title:'标题3',
                // },
            ],
            topInfo:{
                
            },
            topInfo6:[
                // {
                //     modifyDate:'',
                //     infoTitle:'',
                // }
            ],
            currentTop:'今日头条',
            industryTop:{},
            industryTop5:[],
            policyTop:{},
            policyTop5:[],
            productCenterTop:[],
            tldCenterTop:[],
            hotWords:[],
            informationNoticeTop:[],
            productLoading:false,
        }
    },
    components:{
        comNews,
        comProduct,
    },
    created(){
        this.getTop6();
        this.getIndustryTop6();
        this.getPolicyTop6();
        this.getProductCenterTop();
        this.getTldCenterTop();
        this.getHotWords();
        this.getInformationNoticeTop();
        this.getFocusTop();
    },
    methods:{
        getTop6(){
            var url="";
            switch(this.currentTop){
                case '今日头条':
                    url=this.api.getTop;
                    break;
                case '焦点回顾':
                    url=this.api.getFocusTop;
                    break;
                case '企业资讯':
                    url=this.api.getCompanyTop;
                    break;
            }
            this.get(url,{topSize:6}).then(res=>{
                if(res.data[0] != null){
                    this.topInfo.modifyDate=res.data[0].modifyDate.substring(0,10);
                    this.topInfo.infoTitle=res.data[0].infoTitle;
                    this.topInfo.id=res.data[0].id;
                    
                }
                
                
                for(var i=1,j=0; i<res.data.length;i++,j++ ){
                    this.topInfo6[j]=res.data[i];
                    this.topInfo6[j].modifyDate=this.topInfo6[j].modifyDate.substring(0,10);
                }
                this.$forceUpdate();
            }).catch();
        },
        getFocusTop(){
            this.get(this.api.getFocusTop,{topSize:6}).then(res=>{
                if(res.result==200){
                    this.imgs=res.data;
                }
            }).catch();
        },
        getIndustryTop6(){
            this.get(this.api.getIndustryTop6,{topSize:6}).then(res=>{
                if(res.data[0].id){
                    this.getIndustryDetail(res.data[0].id);
                }
                
                for(var i=1,j=0; i<res.data.length;i++,j++ ){
                    this.industryTop5[j]=res.data[i];
                    this.industryTop5[j].createDate=this.industryTop5[j].modifyDate.substring(0,10);
                }
            }).catch();
        },
        getIndustryDetail(id){
            this.get(this.api.getIndustryDetail,{id:id}).then(res=>{
                this.industryTop=res.data;
                this.industryTop.id=id;
                this.industryTop.abstract=removeRichTextLabel(this.industryTop.fgnr);
            }).catch();
        },
        getPolicyTop6(){
            this.get(this.api.getPolicyTop6,{topSize:6}).then(res=>{
                if(res.data[0]){
                    this.getPolicyDetail(res.data[0].id);
                }
                for(var i=1,j=0; i<res.data.length;i++,j++ ){
                    this.policyTop5[j]=res.data[i];
                    this.policyTop5[j].createDate=this.policyTop5[j].modifyDate.substring(0,10);
                }
            }).catch();
        },
        getPolicyDetail(id){
            this.get(this.api.getPolicyDetail,{id:id}).then(res=>{
                this.policyTop=res.data;
                this.policyTop.id=id;
                this.policyTop.abstract=removeRichTextLabel(this.policyTop.fgnr);
            }).catch();
        },
        getProductCenterTop(){
            this.get(this.api.getProductCenterTop,{topSize:4}).then(res=>{
                this.productCenterTop=res.data;
                for(var i=0;i<this.productCenterTop.length;i++){
                    this.productCenterTop[i].infoTitle=this.productCenterTop[i].pname;
                    this.productCenterTop[i].abstract=removeRichTextLabel(this.productCenterTop[i].fgnr);
                    this.productCenterTop[i].fgdw=this.productCenterTop[i].factoryName;
                }
                this.productLoading=true;
            }).catch();
        },
        getTldCenterTop(){
            this.get(this.api.getTldCenterTop,{topSize:6}).then(res=>{
                this.tldCenterTop=res.data;
            }).catch();
        },
        getHotWords(){
            this.get(this.api.hotWords).then(res=>{
                this.hotWords=res.data;
            }).catch();
        },
        getInformationNoticeTop(){
            this.get(this.api.getInformationNoticeTop,{topSize:6}).then(res=>{
                this.informationNoticeTop=res.data;
            }).catch();
        },
        changeTop(top){
            this.currentTop=top;
            this.topInfo={},
            this.topInfo6=[],
            this.getTop6();
            
        },
        getDetail(id,type){
            this.$router.push({ path: '/informationDetail',query: {id: id,type: type}});
        },
        getList(type){
            this.$router.push({ path: '/informationList',query: {type:type}});
        },
        getPCdetail(id,type){
            
            this.$router.push({ path: type=='产品详情'?'/productDetail':'/companyDetail',query: {id: id,type:type}});
        }
    }
    
}